import { LitElement, css, html } from 'lit'

export class DzSearchTree extends LitElement {
    static get properties() {
        return {
          dataset: { type: String }, // ключ localStorage
          initial: { type: String },
          persist: { type: Boolean }
        }
    }

    constructor() {
        super()
        this.initial = "open"
    }

    connectedCallback() {
        super.connectedCallback()
        if (this.persist) {
            window.addEventListener("beforeunload", () => {
                window.localStorage.setItem(this.dataset, JSON.stringify(this.tree_data))
            })
        }
    }

    constructTree(tree_data) {
        let top = []
        let sub = []
        if (!tree_data.children) {
            top.push(html`
                <li @click="${() => this.changeState(tree_data) }" part="item">
                    <a href="${tree_data.URL.href}" part="name">${tree_data.name}</a>
                    <span part="count">${tree_data.URL.cnt}</span>
                </li>`)
        } else {
            tree_data.state = tree_data.state ?? this.initial
            top.push(html`<li @click="${() => this.changeState(tree_data) }" part="${tree_data.state}">${tree_data.name}</li>`)
            if (tree_data.state == "open") {
                for (let child of tree_data.children) {
                    sub.push(this.constructTree(child))
                }
                top.push(html`<ul part="list">${sub}</ul>`)
            }
        }
        return html`${top}`
    }

    changeState(item) {
        item.state = item.state == "open" ? "closed" : "open"
        this.requestUpdate()
    }

    render() {
        this.tree_data = this.tree_data ?? JSON.parse(window.localStorage.getItem(this.dataset))
        if (this.tree_data) {
            return html`${this.constructTree(this.tree_data)}`
        }
    }

    static get styles() {
        return css`
            ul, li {
                list-style: none;
            }
        `
      }
}

window.customElements.define('dz-search-tree', DzSearchTree)